import { render, staticRenderFns } from "./TaskNav.vue?vue&type=template&id=fcd9aba0&scoped=true"
import script from "./TaskNav.vue?vue&type=script&lang=js"
export * from "./TaskNav.vue?vue&type=script&lang=js"
import style0 from "./TaskNav.vue?vue&type=style&index=0&id=fcd9aba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd9aba0",
  null
  
)

export default component.exports